import { render, staticRenderFns } from "./ChangeSubscription.vue?vue&type=template&id=6a6d5a7e"
import script from "./ChangeSubscription.vue?vue&type=script&lang=js"
export * from "./ChangeSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports